<template>
  <svg
    width="23"
    height="27"
    viewBox="0 0 23 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_40002730_3647"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="23"
      height="27"
    >
      <path
        d="M21.1397 26.9663H1.86029C0.832882 26.9663 0 26.1348 0 25.1092V2.82345C0 1.79778 0.832882 0.966309 1.86029 0.966309H14.375L23 9.5767V25.1092C23 26.1348 22.1671 26.9663 21.1397 26.9663Z"
        fill="url(#paint0_linear_40002730_3647)"
      />
    </mask>
    <g mask="url(#mask0_40002730_3647)">
      <path
        d="M21.1397 26.9663H1.86029C0.832882 26.9663 0 26.1348 0 25.1092V2.82345C0 1.79778 0.832882 0.966309 1.86029 0.966309H14.375L23 9.5767V25.1092C23 26.1348 22.1671 26.9663 21.1397 26.9663Z"
        fill="url(#paint1_linear_40002730_3647)"
      />
      <path
        d="M4.62644 16.2865H5.81044V22.2065H4.62644V16.2865ZM7.26706 16.2865H8.57906L9.58706 19.0545C9.65106 19.2412 9.7124 19.4305 9.77106 19.6225C9.82973 19.8145 9.8884 20.0065 9.94706 20.1985H9.98706C10.0511 20.0065 10.1097 19.8145 10.1631 19.6225C10.2217 19.4305 10.2831 19.2412 10.3471 19.0545L11.3311 16.2865H12.6431V22.2065H11.5631V19.7345C11.5631 19.5959 11.5684 19.4439 11.5791 19.2785C11.5897 19.1079 11.6004 18.9372 11.6111 18.7665C11.6271 18.5905 11.6431 18.4199 11.6591 18.2545C11.6751 18.0839 11.6911 17.9292 11.7071 17.7905H11.6751L11.1951 19.1825L10.2831 21.6705H9.60306L8.68306 19.1825L8.21106 17.7905H8.17906C8.19506 17.9292 8.21106 18.0839 8.22706 18.2545C8.24306 18.4199 8.25906 18.5905 8.27506 18.7665C8.29106 18.9372 8.3044 19.1079 8.31506 19.2785C8.32573 19.4439 8.33106 19.5959 8.33106 19.7345V22.2065H7.26706V16.2865ZM16.6392 22.3185C16.2339 22.3185 15.8579 22.2519 15.5112 22.1185C15.1645 21.9852 14.8632 21.7905 14.6072 21.5345C14.3565 21.2785 14.1592 20.9612 14.0152 20.5825C13.8712 20.2039 13.7992 19.7665 13.7992 19.2705C13.7992 18.7852 13.8739 18.3505 14.0232 17.9665C14.1725 17.5825 14.3752 17.2572 14.6312 16.9905C14.8872 16.7239 15.1859 16.5212 15.5272 16.3825C15.8739 16.2439 16.2445 16.1745 16.6392 16.1745C17.0659 16.1745 17.4285 16.2519 17.7272 16.4065C18.0312 16.5612 18.2792 16.7372 18.4712 16.9345L17.8392 17.6865C17.6952 17.5479 17.5325 17.4305 17.3512 17.3345C17.1752 17.2385 16.9512 17.1905 16.6792 17.1905C16.4339 17.1905 16.2072 17.2385 15.9992 17.3345C15.7965 17.4252 15.6205 17.5585 15.4712 17.7345C15.3272 17.9105 15.2125 18.1239 15.1272 18.3745C15.0472 18.6252 15.0072 18.9105 15.0072 19.2305C15.0072 19.8759 15.1539 20.3825 15.4472 20.7505C15.7405 21.1132 16.1779 21.2945 16.7592 21.2945C16.9032 21.2945 17.0419 21.2759 17.1752 21.2385C17.3085 21.2012 17.4179 21.1452 17.5032 21.0705V19.9025H16.4552V18.9345H18.5592V21.6065C18.3565 21.8039 18.0899 21.9719 17.7592 22.1105C17.4285 22.2492 17.0552 22.3185 16.6392 22.3185Z"
        fill="white"
      />
      <g filter="url(#filter0_d_40002730_3647)">
        <path
          d="M23 9.5767H16.375C15.2704 9.5767 14.375 8.68127 14.375 7.5767V0.966309L23 9.5767Z"
          fill="url(#paint2_linear_40002730_3647)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_40002730_3647"
        x="-8.625"
        y="-23.0337"
        width="58.625"
        height="58.6104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="2"
          dy="1"
        />
        <feGaussianBlur stdDeviation="12.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_40002730_3647"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_40002730_3647"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_40002730_3647"
        x1="11.5"
        y1="0.966309"
        x2="11.5"
        y2="26.9663"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7979" />
        <stop
          offset="1"
          stop-color="#E85555"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_40002730_3647"
        x1="11.5"
        y1="0.966309"
        x2="11.5"
        y2="26.9663"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED81FF" />
        <stop
          offset="1"
          stop-color="#DC5DD7"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_40002730_3647"
        x1="16.2776"
        y1="-1.73499"
        x2="18.6797"
        y2="9.57836"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F171BE" />
        <stop
          offset="1"
          stop-color="#D823D1"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
